module.exports = __webpack_public_path__ + "img/beacons.852c78df.svg";